module.exports = __webpack_public_path__ + "img/MapPicsArabia.5b734611.webp";